import { render } from "./checkbox-tree-template.vue?vue&type=template&id=0e9ec12b&lang=true"
import script from "./checkbox-tree-template.vue?vue&type=script&lang=js"
export * from "./checkbox-tree-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__